import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { DashboardComponent } from './dashboard/dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    data: { page: 'list' },
    canActivate: [MsalGuard],
  },
  {
    path: 'matching/new',
    redirectTo: 'matching',
    pathMatch: 'full',
  },
  {
    path: ':slug',
    component: DashboardComponent,
    data: { page: 'list' },
    canActivate: [MsalGuard],
  },
  {
    path: ':slug/:deeplink',
    component: DashboardComponent,
    data: { page: 'dashboard' },
    canActivate: [MsalGuard],
  },
  {
    path: ':slug/:deeplink/:id',
    component: DashboardComponent,
    data: { page: 'dashboard' },
    canActivate: [MsalGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
